import React, {Component} from 'react';
import Modal from 'react-modal';
import axios from 'axios';
import {withAlert} from 'react-alert'
import "imrc-datetime-picker/dist/imrc-datetime-picker.css";
import {config} from '../../config';
import 'rc-time-picker/assets/index.css';
import Loading from "../Loading";
import { getMapLib, createMapInstance, isNeshan } from '../../utils/mapHelper';

const nmp_mapboxgl = getMapLib();

let map;
let coordinates = [];
let polygonMarkers = [];
let drawingEnabled = true;

class AddArea extends Component{

    constructor(props) {
        super(props);

        this.state={
            data: [],
            mapTypesListIsOpen: false,
            isSaveAreaOpen:false,
            mapType: isNeshan ? 'neshanVector' : 'osm',
            tracers:[],
            selectedTracer:0,
            sendSms:0,
            areaTitle:'',
            loading:false,
            pointCount: 0
        };

        this.onScriptLoad = this.onScriptLoad.bind(this);
        this.closeMapTypsList = this.closeMapTypsList.bind(this);
        this.reloadMap = this.reloadMap.bind(this);
        this.saveNewArea = this.saveNewArea.bind(this);
        this.finishDrawing = this.finishDrawing.bind(this);
        this.resetDrawing = this.resetDrawing.bind(this);
        this.zoomIn = this.zoomIn.bind(this);
        this.zoomOut = this.zoomOut.bind(this);
    }
    finishDrawing() {
        if (coordinates.length < 3) {
            this.props.alert.error("برای ایجاد محدوده، حداقل ۳ نقطه روی نقشه انتخاب کنید.");
            return;
        }
        drawingEnabled = false;
        this.drawPolygonOnMap();
        this.setState({ isSaveAreaOpen: true });
    }
    resetDrawing() {
        coordinates = [];
        for (let m of polygonMarkers) {
            m.remove();
        }
        polygonMarkers = [];
        if (map.getLayer('polygon-fill')) map.removeLayer('polygon-fill');
        if (map.getLayer('polygon-outline')) map.removeLayer('polygon-outline');
        if (map.getSource('polygon')) map.removeSource('polygon');
        drawingEnabled = true;
        this.setState({ pointCount: 0, isSaveAreaOpen: false });
    }
    onScriptLoad() {
        map = createMapInstance({
            container: document.getElementById("myMap"),
            zoom: 14,
            center: [46.270212, 38.0843038]
        });

        if (map.doubleClickZoom) {
            map.doubleClickZoom.disable();
        }

        drawingEnabled = true;
        coordinates = [];
        polygonMarkers = [];
        this.setState({ pointCount: 0 });

        map.on('click', (e) => {
            if (!drawingEnabled) return;

            const isFirstPoint = coordinates.length === 0;

            coordinates.push({
                lat: e.lngLat.lat,
                lng: e.lngLat.lng
            });

            let markerEl = document.createElement('div');
            markerEl.style.width = isFirstPoint ? '14px' : '10px';
            markerEl.style.height = isFirstPoint ? '14px' : '10px';
            markerEl.style.backgroundColor = isFirstPoint ? '#28a745' : '#3D8DF9';
            markerEl.style.borderRadius = '50%';
            markerEl.style.border = '2px solid #fff';
            markerEl.style.cursor = 'pointer';
            if (isFirstPoint) {
                markerEl.title = 'نقطه شروع (برای بستن محدوده پس از حداقل ۳ نقطه کلیک کنید)';
            }

            let m = new nmp_mapboxgl.Marker({ element: markerEl })
                .setLngLat([e.lngLat.lng, e.lngLat.lat])
                .addTo(map);
            polygonMarkers.push(m);

            if (isFirstPoint) {
                markerEl.addEventListener('click', (ev) => {
                    ev.stopPropagation();
                    if (coordinates.length >= 3 && drawingEnabled) {
                        this.finishDrawing();
                    }
                });
            }

            this.setState({ pointCount: coordinates.length });
            this.drawPolygonOnMap();
        });

        map.on('dblclick', (e) => {
            if (!drawingEnabled) return;
            e.preventDefault();
            // Remove potential duplicate point from the second click of dblclick
            if (coordinates.length > 3) {
                const last = coordinates[coordinates.length - 1];
                const prev = coordinates[coordinates.length - 2];
                if (Math.abs(last.lat - prev.lat) < 0.0001 && Math.abs(last.lng - prev.lng) < 0.0001) {
                    coordinates.pop();
                    const lastM = polygonMarkers.pop();
                    if (lastM) lastM.remove();
                }
            }
            if (coordinates.length >= 3) {
                this.finishDrawing();
            }
        });
    }
    drawPolygonOnMap() {
        if (map.getLayer('polygon-fill')) map.removeLayer('polygon-fill');
        if (map.getLayer('polygon-outline')) map.removeLayer('polygon-outline');
        if (map.getSource('polygon')) map.removeSource('polygon');

        if (coordinates.length < 2) return;

        let coords = coordinates.map(c => [c.lng, c.lat]);
        let closed = [...coords, coords[0]];

        map.addSource('polygon', {
            type: 'geojson',
            data: {
                type: 'Feature',
                geometry: {
                    type: 'Polygon',
                    coordinates: [closed]
                }
            }
        });
        map.addLayer({
            id: 'polygon-fill',
            type: 'fill',
            source: 'polygon',
            paint: {
                'fill-color': '#3D8DF9',
                'fill-opacity': 0.3
            }
        });
        map.addLayer({
            id: 'polygon-outline',
            type: 'line',
            source: 'polygon',
            paint: {
                'line-color': '#3D8DF9',
                'line-width': 2
            }
        });
    }
    chanegMapType(type){
        this.onScriptLoad();
        this.setState({mapType: type , isInfoBoxOpen: false});
    }
    closeMapTypsList(){
        this.setState({mapTypesListIsOpen: false});
    }
    reloadMap(){
        this.resetDrawing();
        this.setState({isSaveAreaOpen: false , areaTitle: '' , selectedTracer: 0, pointCount: 0 });
    }
    zoomIn(){
        if (map) {
            map.zoomIn();
        }
    }
    zoomOut(){
        if (map) {
            map.zoomOut();
        }
    }
    saveNewArea(){
        this.setState({loading: true});

        let data = {
            'send_sms' : this.state.sendSms ,
            'name': this.state.areaTitle ,
            'coordinates': coordinates
        };
        let req = {
            method: 'post',
            url: config.baseUrl + 'api/v2/clients/tracers/'+this.state.selectedTracer+'/geo-areas',
            headers: {
                Authorization: "Bearer " + config.token
            },
            data: data,
        };
        axios(req
        ).then((resp) => {
            if(resp.data.status === 1) {
                this.setState({isSaveAreaOpen: false , loading:false});
                this.props.history.push('/areaslist');
                coordinates = [];
                this.props.alert.success('ثبت با موفقیت انجام شد.')
            }

        }).catch((err) => {
            console.log(err);
            this.setState({loading:false});
            this.props.alert.error('فیلد ها را به دقت پر کنید.')

        });
    }
    componentDidMount() {
        this.onScriptLoad();

        let req = {
            method: 'get',
            url: config.baseUrl + 'api/v2/clients/tracers',
            headers: {
                Authorization: "Bearer " + config.token
            }
        };
        axios(req).then((resp) => {
            if (resp.data.status === 1) {
                this.setState({
                    tracers: resp.data.data
                });
            }
        }).catch(err => {
            console.log(err);
        });
    }

    render(){


        return(
            <div>
                <Loading loading={this.state.loading}/>
                <div id={"myMap"} className='Map col-lg-12 col-md-12'/>

                {/* Floating instructions and next step action bar */}
                {!this.state.isSaveAreaOpen && (
                    <div style={{
                        position: 'absolute',
                        top: '15px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 999,
                        backgroundColor: 'rgba(255, 255, 255, 0.95)',
                        padding: '8px 18px',
                        borderRadius: '24px',
                        boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
                        fontSize: '13px',
                        direction: 'rtl',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px'
                    }}>
                        {this.state.pointCount < 3 ? (
                            <span>روی نقشه کلیک کنید تا نقاط محدوده مشخص شوند (حداقل ۳ نقطه — ثبت شده: {this.state.pointCount})</span>
                        ) : (
                            <>
                                <span style={{ fontWeight: 'bold', color: '#28a745' }}>{this.state.pointCount} نقطه ثبت شد.</span>
                                <button
                                    onClick={this.finishDrawing}
                                    className='blueBtn btn'
                                    style={{ padding: '6px 18px', fontSize: '13px', margin: 0, borderRadius: '15px' }}
                                >
                                    تکمیل و مرحله بعد
                                </button>
                            </>
                        )}
                        {this.state.pointCount > 0 && (
                            <button
                                onClick={this.resetDrawing}
                                className='pinkBtn btn'
                                style={{ padding: '6px 14px', fontSize: '13px', margin: 0, borderRadius: '15px' }}
                            >
                                شروع مجدد
                            </button>
                        )}
                    </div>
                )}

                <button title='کوچک‌نمایی' className='map-btn' style={{bottom: '120px'}} onClick={this.zoomOut}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3D8DF9" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ display: "inline-block", verticalAlign: "middle", marginTop: "3px" }}>
                        <line x1="5" y1="12" x2="19" y2="12" />
                    </svg>
                </button>
                <button title='بزرگ‌نمایی' className='map-btn' style={{bottom: '170px'}} onClick={this.zoomIn}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3D8DF9" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ display: "inline-block", verticalAlign: "middle", marginTop: "3px" }}>
                        <line x1="12" y1="5" x2="12" y2="19" />
                        <line x1="5" y1="12" x2="19" y2="12" />
                    </svg>
                </button>
                <button title='بارگذاری مجدد' className='map-btn' style={{bottom: '70px'}} onClick={this.reloadMap}>
                    <i className='icon-mapRefresh'></i>
                </button>
                <button title='نقشه ها' className='map-btn' style={{bottom: '20px'}} onClick={()=>this.setState({mapTypesListIsOpen: true})}>
                    <i className='icon-world'></i>
                </button>

                <div className={'infoBox saveArea'} style={{display: this.state.isSaveAreaOpen === true ? 'block' : 'none'}}>
                    <div className='half'>
                        <div className='input-div '>
                            <h5>عنوان</h5>
                            <div className='input-group'>
                                <input onChange={(e)=>{this.setState({areaTitle: e.target.value})}} className='input' placeholder='محدوده شرکت' style={{textAlign: 'right' , paddingRight: '0' , direction:'rtl'}} />
                            </div>
                        </div>
                    </div>
                    <div className='half'>
                        <div className='input-div '>
                            <h5>ردیاب</h5>
                            <div className='input-group'>
                                <select onChange={(e)=>{this.setState({selectedTracer: e.target.value})}}>
                                    <option disabled selected default value={0}> ردیاب</option>
                                    {this.state.tracers.map((key)=>
                                        <option value={key.id}>{key.title}</option>
                                    )}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className='input-div ' style={{padding: '0 10px'}}>
                        <h5>نحوه اطلاع رسانی(در صورت خروج از محدوده مشخص شده)</h5>
                        <div className='input-group'>
                            <select onChange={(e)=>{this.setState({sendSms:e.target.value})}}>
                                <option value={0}>ناتیفیکیشن</option>
                            </select>
                        </div>
                    </div>
                    <button onClick={this.saveNewArea} className='blueBtn btn' style={{padding: '12px 30px'}}>ذخیره محدوده انتخاب شده</button>
                    <button className='pinkBtn btn' style={{marginRight: '12px' , padding: '12px 15px'}} onClick={this.reloadMap}>حذف محدوده انتخابی</button>
                </div>
                <Modal
                    isOpen={this.state.mapTypesListIsOpen}
                    onRequestClose={this.closeMapTypsList}
                    style={{content : {top: 'calc(100vh / 5)'  ,left: '40%' , right: '40%'}}}
                >
                    <p>نقشه ها</p>
                    <ul>
                        {isNeshan ? (
                            <li>
                                <button onClick={()=>this.chanegMapType("neshanVector")}>
                                    <img src={require(`../../image/Ellipse-${this.state.mapType === "neshanVector" ?'1':'0'}@2x.png`)} alt="نقشه نشان"/>
                                    <p>نقشه نشان</p>
                                    <span className='radio'>
                                        <img src={require(`../../image/radio${this.state.mapType === "neshanVector" ? 'S' : 'U'}.png`)} alt="انتخاب"/>
                                    </span>
                                </button>
                            </li>
                        ) : (
                            <li>
                                <button onClick={()=>this.chanegMapType("osm")}>
                                    <img src={require(`../../image/Ellipse-${this.state.mapType === "osm" ?'1':'0'}@2x.png`)} alt="OpenStreetMap"/>
                                    <p>نقشه OpenStreetMap</p>
                                    <span className='radio'>
                                        <img src={require(`../../image/radio${this.state.mapType === "osm" ? 'S' : 'U'}.png`)} alt="انتخاب"/>
                                    </span>
                                </button>
                            </li>
                        )}
                    </ul>
                </Modal>

            </div>
        );
    }
}
export default withAlert(AddArea);